export const INCREMENT_SCANNED_COUNT = 'INCREMENT_SCANNED_COUNT';
export const DECREMENT_SCANNED_COUNT = 'DECREMENT_SCANNED_COUNT';
export const INCREMENT_PACKED_COUNT = 'INCREMENT_PACKED_COUNT';
export const DECREMENT_PACKED_COUNT = 'DECREMENT_PACKED_COUNT';